/**
 * index.js
 * - All our useful JS goes here, awesome!
 */

/* <style lang="scss">
	@import "/styles/index.scss";
</style>  */
// import Vue from 'vue'
// require('/styles/index.css')
import '../styles/index.css';

// This will eventually be randomised
import text1 from '!raw-loader!../texts/text_1.txt';
//alert("*" + text1 + "*")

// Vue.prototype.$keyDownTime = 0;  // Leave these here, just in case existing way has problems
// Vue.prototype.$keyUpTime = 0;
var app = new Vue({

	el: '#app',

	data: {
    	product: 'Socks',
    	image: 'https://www.vuemastery.com/images/challenges/vmSocks-green-onWhite.jpg',
		debugText: '',
		$keyDownTime: 0,
		$keyUpTime: 0,

		$keyDownPrev: 0,	// From Tappy code
		$keyUpPrev: 0,		//
		$keyPrev: '',		//
		$groupPrev: '',		//
		$holdTime: 0,		//
		$flightTime: 0,		//
		$latencyTime: 0,	//

		teleContent: text1,
		barStyle: "width:15%",
		progressPct: '0% complete'

		// function() {
		// 	return {
		// 		teleText: text1
		// 	}
		// }
	}, 
	
	methods: {
		//~~~~~~~~~~~~~~~~~~~
		// To plug a series of values into an output string:
		// 	 var fmt = require('sprintf-js').sprintf
		// To retrun a fixed number of decimal places:
		//   alert((3/7).toFixed(2)) 
		// To zero pad a number (or string)
		//   this.zeroPad(num, numZeros) This is defined herein
		//~~~~~~~~~~~~~~~~~~~

		lostFocus: function(event) {
			//event.preventDefault(); ccccc
			//event.cancellable=false;
			//event.stopImmediatePropagation();
		 },

		keyDown: function(event) {
			this.$keyDownTime = performance.now()
		},			
		keyUp: function(event) {
			var code = null
			var holdTime = 0
			this.$keyUpTime = performance.now() 

			if (event.keyCode !== undefined) {
    			// Handle the event with KeyboardEvent.keyCode
				code=event.keyCode
  			} else {
				// Depends on browser, so this is the fallback
				code=event.code
			}
			holdTime = this.$keyUpTime - this.$keyDownTime
			var dateTime = this.formatDate(new Date(Date.now()))
			//alert(dateTime)
			var len
			if (holdTime < 100) {
				len = 5
			} else {
				len = 6
			}

			if ( typeof this.totalCount == 'undefined' ) {
				// It has not... perform the initialization
				this.totalCount = 0;
				this.inclCount = 0;
			}
			++this.totalCount;
			++this.inclCount;

			//this.progressPct = string(this.totalCnt/1500)

			// Indicate the count so far
			console.log('totalCount: ' + (this.totalCount));
			console.log(dateTime + " " + event.key + " (" + code + ") " + String(holdTime).substr(0,len))

			// Process timings & return whether its an included character (as per Tappy)
			// Saving the details is also done in this function
			if (this.includeKey(code)) {
				// Add to debug output
				this.debugText = this.debugText + '\n' + (dateTime + "\t" + event.key + 
					" (" + code + ")\t" + String(holdTime).substr(0,len))
				// Position cursor at bottom of existing text rather than top
				debugTextArea.disabled=false
				debugTextArea.focus()
				debugTextArea.selectionStart=this.debugText.length + 50
				debugTextArea.disabled=true
				inputText.focus()
				// Add to array

				// If 20 chars then calculate variance to date & reset count
				// Valid. 1) Increment counter & add to array 2) If >20 then calculate variance 3) Show var to date
				// 4) If 1500 then show complete

				// [1]  
				// .totalCount is static within keyUp function - see https://stackoverflow.com/questions/1535631/static-variables-in-javascript#:~:text=The%20static%20keyword%20allows%20you,or%20methods%20in%20a%20class.&text=You%20might%20take%20advantage%20of,means%20they%20can%20have%20properties.&text=If%20you%20call%20that%20function,the%20counter%20is%20being%20incremented.
				// Check to see if it has been initialized

			}

			var tarea = document.getElementById('teleText');
			var inarea = document.getElementById('inputText');
			//console.log("tarea: " + tarea)
			this.highlight(tarea,inarea);  // This does the scrolling of the teletext area

			// *** TESTING ONLY - forces totalCount to be the length of text ratherthan keystrokes
			// 	Also should be using inclCount
			this.totalCount=inarea.value.length
			console.log('totalCount: ' + this.totalCount)
			if (this.totalCount<=1500){
				// The factor '2' below is 100/(endwidth - startwidth). Then plus startwidth
				this.progressPct = String((100*this.totalCount/1500).toFixed(0)) + '% complete'
				this.barStyle = "width:" + String(this.totalCount*100/(1500*(100/45))+15) + '%'
			} else {
				this.progressPct = '100% complete'
				//this.barStyle = "width:" + String(70) + '%'
			}
		},
		includeKey: function includeKey(code) {
			// **** Needs all the code added here
			return true;
		},
		formatDate: function formatDate(rawDate) {
			var year = String(rawDate.getFullYear()).substr(2,2)
			var month = String(rawDate.getMonth() + 1)
			if (month.length == 1) {
				month = '0' + month
			}
			var day = String(rawDate.getDate())
			if (day.length == 1) {
				day = '0' + day
			}
			var hour = String(rawDate.getHours())
			if (hour.length == 1) {
				hour = '0' + hour
			}
			var minute = String(rawDate.getMinutes())
			if (minute.length == 1) {
				minute = '0' + minute
			}
			var second = String(rawDate.getSeconds())
			if (second.length == 1) {
				second = '0' + second
			}
			return year + month + day + " " + hour + ":" + minute + ":" + 
				second + "." + String(rawDate.getMilliseconds()).substr(0,3);
		},
		highlight: function selectTextAreaLine(a,b) {
			// var start = inputText.length, //a.selectionStart,
			// 	len = 400,
			// 	pos = start + len;
			//var inputText = document.getElementById('inputText')

			// Max characters in text area is 80 * 10 = 800
			// If more than 30% then start scrolling
			console.log('Length of inputText: ' + b.value.length)
			if (b.value.length > a.cols*4) {
				var start = b.value.length - 240
				a.disabled = false	
				a.focus()
				a.selectionStart= start
				a.selectionEnd=start + 200
				// Calculate 
				// we need the number of chars in a row
				var charsPerRow = a.cols + 8;	// Scroll 10% less to allow for CRLF's
				// we need to know at which row our selection starts
				//var selectionRow = (a.selectionStart - (a.selectionStart % charsPerRow)) / charsPerRow;
				var selectionRow = (a.selectionStart) / charsPerRow;

				// we need to scroll to this row but scrolls are in pixels,
				// so we need to know a row's height, in pixels
				var lineHeight = a.clientHeight / a.rows;
				// scroll !!
				//a.scrollTop = lineHeight * selectionRow;	 Whole lines			 
				a.scrollTop = lineHeight * selectionRow;
				a.disabled=true
				b.focus()
			}
		},
		highlight1_Notused: function selectTextAreaLine(tarea,lineNum) {
			// From https://stackoverflow.com/questions/13650534/how-to-select-line-of-text-in-textarea
    		lineNum--; // array starts at 0
			//console.log(tarea.value)
    		var lines = tarea.value.split("\n") ;
    		// calculate start/end
    		var startPos = 0, endPos = tarea.value.length;
    		for(var x = 0; x < lines.length; x++) {
        		if(x == lineNum) {
            		break;
        		}
				// Set start as zero
        		startPos += (lines[x].length+1);        		
		      }
    		var endPos = lines[lineNum].length+startPos;
			// In this case we want to highlight all text up to the 
			// chosen line, so reset startPos
			startPos = 0
			// do selection
			tarea.disabled=false

    		// Chrome / Firefox
    		if(typeof(tarea.selectionStart) != "undefined") {
        		//tarea.focus();
        		tarea.selectionStart = startPos;
				tarea.selectionEnd = endPos;
				tarea.focus()
        		//return true;
    		} else {
				// IE
				if (document.selection && document.selection.createRange) {
					//tarea.focus();
					tarea.select();
					var range = document.selection.createRange();
					range.collapse(true);
					range.moveEnd("character", endPos);
					range.moveStart("character", startPos);
					range.select();
					tarea.focus()
					//return true;
				}
			}
			tarea.selectionStart = tarea.length;
			//tarea.selectionEnd = tarea.length;
			tarea.focus()
			tarea.disabled=true
			// XXX As soon as it loses focus the highlight also disappears
			//inputText.focus()
		},	
		zeroPad: function zeroPad(num, numZeros) {
			var n = Math.abs(num);
			var zeros = Math.max(0, numZeros - Math.floor(n).toString().length );
			var zeroString = Math.pow(10,zeros).toString().substr(1);
			if( num < 0 ) {
				zeroString = '-' + zeroString;
			}
			return zeroString+n;
		}	
	}
})
